/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BookingEntity = {
    id: string;
    createdAt: string;
    updatedAt: string;
    bookingStatus: BookingEntity.bookingStatus;
    organizationId: string;
    orderId: string | null;
    meetingId: string;
    /**
     * The date and time until the booking doesn't block a spot in the meeting anymore.
     */
    exclusiveUntil: string | null;
    guestId: string | null;
    customerId: string | null;
    multipassId: string | null;
    courseGroupId: string | null;
    multipassProductId: string | null;
    priceInMillsOverride: number | null;
    replaced: boolean;
    rebateCodeId: string;
    /**
     * When set, statutory revocation (Widerruf) is blocked for this booking.
     */
    revocationBlockedAt: string | null;
    revocationBlockedReason: BookingEntity.revocationBlockedReason | null;
};
export namespace BookingEntity {
    export enum bookingStatus {
        RESERVED = 'RESERVED',
        CLAIMED = 'CLAIMED',
        FULFILLED = 'FULFILLED',
        REFUNDED = 'REFUNDED',
        CANCELLED = 'CANCELLED',
        CANCELLED_REFUNDED = 'CANCELLED_REFUNDED',
        REVOKED = 'REVOKED',
        WITHDRAWN = 'WITHDRAWN',
    }
    export enum revocationBlockedReason {
        WAIVER = 'WAIVER',
        MULTIPASS_USED = 'MULTIPASS_USED',
    }
}

